/**
 * fit-form-assist.js
 * Clarity: contact form partial fills / abandon — inject progress + required guidance
 * even when page section HTML is stuck on an older theme-editor snapshot.
 */
(function () {
  'use strict';
  if (window.__fitFormAssist) return;
  window.__fitFormAssist = true;

  function path() {
    return (location.pathname || '/').replace(/\/+$/, '') || '/';
  }
  function isContact() {
    return /\/pages\/contact/i.test(path());
  }

  function css() {
    if (document.getElementById('fit-form-assist-css')) return;
    var s = document.createElement('style');
    s.id = 'fit-form-assist-css';
    s.textContent = [
      '.fit-fa-wrap{margin:0 0 16px;padding:12px 14px;background:var(--bone-2,#f4f1ec);border:1px solid var(--line,rgba(0,0,0,.1));border-radius:12px}',
      '.fit-fa-steps{display:flex;gap:8px;margin:0 0 10px}',
      '.fit-fa-step{flex:1;text-align:center}',
      '.fit-fa-step .d{width:22px;height:22px;margin:0 auto 4px;border-radius:50%;background:#ddd;color:#445;font:800 11px/22px var(--font-display,system-ui);}',
      '.fit-fa-step .l{font-size:10.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#889}',
      '.fit-fa-step.on .d{background:#1a2530;color:#5ec4c0;box-shadow:0 0 0 3px rgba(24,167,163,.25)}',
      '.fit-fa-step.done .d{background:#3c6b7c;color:#fff}',
      '.fit-fa-step.on .l{color:#1a2530}',
      '.fit-fa-bar{height:4px;background:rgba(0,0,0,.08);border-radius:3px;overflow:hidden;margin:0 0 8px}',
      '.fit-fa-bar>i{display:block;height:100%;width:15%;background:#3c6b7c;transition:width .25s ease}',
      '.fit-fa-status{margin:0;font-size:13px;line-height:1.4;color:#334;min-height:1.2em}',
      '.fit-fa-status.err{color:#a32d2d;font-weight:700}',
      '.fit-fa-status.ok{color:#2a4f5c;font-weight:700}',
      '.fit-fa-invalid{border-color:#c83c3c!important;background:rgba(200,60,60,.04)!important}',
      '.fit-fa-valid{border-color:rgba(24,167,163,.55)!important}',
      '.fit-fa-meta{margin:6px 0 0;font-size:12.5px;color:#667}',
      'label.fit-fa-req-mark::after{content:" *";color:#3c6b7c;font-weight:900}'
    ].join('');
    (document.head || document.documentElement).appendChild(s);
  }

  function findForm() {
    var card = document.querySelector('.ct-form-card form') || document.querySelector('form[action*="/contact"]') || document.querySelector('.ct-body form');
    return card;
  }

  function field(form, sel) {
    return form.querySelector(sel);
  }

  function enhanceContact() {
    var form = findForm();
    if (!form || form.getAttribute('data-fit-fa')) return;
    form.setAttribute('data-fit-fa', '1');
    css();

    var name = field(form, 'input[name="contact[name]"]');
    var email = field(form, 'input[name="contact[email]"]');
    var body = field(form, 'textarea[name="contact[body]"]');
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!name || !email || !body || !btn) return;

    // Required markers on labels
    [name, email, body].forEach(function (el) {
      try {
        var lab = el.id ? form.querySelector('label[for="' + el.id + '"]') : el.closest('.ct-field') && el.closest('.ct-field').querySelector('label');
        if (lab && !lab.classList.contains('fit-fa-req-mark')) lab.classList.add('fit-fa-req-mark');
      } catch (e) {}
    });
    if (!body.getAttribute('minlength')) body.setAttribute('minlength', '10');

    var wrap = document.createElement('div');
    wrap.className = 'fit-fa-wrap';
    wrap.innerHTML =
      '<div class="fit-fa-steps" aria-hidden="true">' +
      '<div class="fit-fa-step on" data-s="1"><div class="d">1</div><div class="l">Topic</div></div>' +
      '<div class="fit-fa-step" data-s="2"><div class="d">2</div><div class="l">Contact</div></div>' +
      '<div class="fit-fa-step" data-s="3"><div class="d">3</div><div class="l">Message</div></div>' +
      '</div>' +
      '<div class="fit-fa-bar"><i></i></div>' +
      '<p class="fit-fa-status" role="status" aria-live="polite">Step 1 of 3 — pick a topic, then your name &amp; email.</p>' +
      '<p class="fit-fa-meta">3 required fields · reply in 1–2 business days</p>';

    var lead = form.parentNode && form.parentNode.querySelector('.lead');
    if (lead && lead.parentNode) lead.parentNode.insertBefore(wrap, lead.nextSibling);
    else form.insertBefore(wrap, form.firstChild);

    var bar = wrap.querySelector('.fit-fa-bar > i');
    var status = wrap.querySelector('.fit-fa-status');
    var meta = wrap.querySelector('.fit-fa-meta');
    var steps = wrap.querySelectorAll('.fit-fa-step');

    function okName() {
      return (name.value || '').trim().length > 1;
    }
    function okEmail() {
      return email.checkValidity && email.checkValidity() && (email.value || '').indexOf('@') > 0;
    }
    function okBody() {
      return (body.value || '').trim().length >= 10;
    }

    function paint(el, ok) {
      if (!el) return;
      el.classList.toggle('fit-fa-invalid', !ok && (el.value || '').length > 0);
      el.classList.toggle('fit-fa-valid', ok);
    }

    function sync() {
      var n = okName(),
        e = okEmail(),
        b = okBody();
      paint(name, n);
      paint(email, e);
      paint(body, b);
      var step = 1;
      if (n || e) step = 2;
      if (n && e) step = b ? 3 : 2;
      steps.forEach(function (el) {
        var s = parseInt(el.getAttribute('data-s'), 10);
        el.classList.toggle('on', s === step);
        el.classList.toggle('done', s < step || (s === 3 && n && e && b));
      });
      var pct = 15 + (n ? 28 : 0) + (e ? 28 : 0) + (b ? 29 : 0);
      if (bar) bar.style.width = pct + '%';
      var left = 3 - (n ? 1 : 0) - (e ? 1 : 0) - (b ? 1 : 0);
      status.classList.remove('err', 'ok');
      if (left <= 0) {
        status.textContent = 'Ready to send — hit Send message.';
        status.classList.add('ok');
      } else if (step === 1) status.textContent = 'Step 1 of 3 — topic selected. Next: name & email.';
      else if (!n || !e)
        status.textContent =
          'Step 2 of 3 — add ' + (!n && !e ? 'name and email' : !n ? 'your name' : 'your email') + '.';
      else status.textContent = 'Step 3 of 3 — write a short message, then send.';
      if (meta)
        meta.textContent =
          left <= 0
            ? 'All set · reply in 1–2 business days'
            : left + ' required field' + (left === 1 ? '' : 's') + ' left · reply in 1–2 business days';
    }

    [name, email, body].forEach(function (el) {
      el.addEventListener('input', sync);
      el.addEventListener('blur', sync);
    });
    form.querySelectorAll('input[name="contact[subject]"]').forEach(function (r) {
      r.addEventListener('change', sync);
    });
    sync();

    btn.addEventListener('click', function () {
      sync();
      var first = null;
      if (!okName()) first = name;
      else if (!okEmail()) first = email;
      else if (!okBody()) first = body;
      if (first) {
        status.classList.add('err');
        status.textContent = 'Almost there — fill the highlighted required fields, then Send.';
        try {
          first.focus({ preventScroll: false });
          first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (e1) {}
      }
    });

    form.addEventListener('submit', function () {
      if (form.checkValidity && !form.checkValidity()) return;
      try {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        if (btn.tagName === 'BUTTON') btn.textContent = 'Sending…';
        status.classList.remove('err');
        status.classList.add('ok');
        status.textContent = 'Sending your message…';
      } catch (e2) {}
    });
  }

  function boot() {
    try {
      if (isContact()) enhanceContact();
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 400);
})();
/* fit-custom-boot — page-cache bypass: measure example + strip magnet-inside fields (All-LOXX) */
(function () {
  try {
    if (!/\/pages\/custom-fit(?:-request|-v2)?\/?$/.test(location.pathname || '')) return;
    if (window.__FIT_CUSTOM_BOOT) return;
    var mark = 'custom-measure-example';
    var html0 = document.documentElement.innerHTML || '';
    var hasExample = document.querySelector('img[src*="custom-measure-example"]') || html0.indexOf(mark) !== -1;
    var hasInside =
      html0.indexOf('name="in_top_w"') !== -1 ||
      html0.indexOf('name="in_bot_w"') !== -1 ||
      html0.indexOf('name="in_h"') !== -1 ||
      html0.indexOf('Inside width') !== -1 ||
      html0.indexOf('Inside height') !== -1 ||
      html0.indexOf('Helps magnet placement') !== -1;
    var hasAllSeven =
      html0.indexOf('all 7 measures') !== -1 &&
      html0.indexOf('name="out_mid_w"') !== -1 &&
      html0.indexOf('name="out_mid_h"') !== -1 &&
      html0.indexOf('name="out_diag_tl_br"') !== -1 &&
      html0.indexOf('name="out_diag_tr_bl"') !== -1;
    if (hasExample && !hasInside && hasAllSeven) return;
    window.__FIT_CUSTOM_BOOT = true;

    function runScripts(root) {
      if (!root) return;
      root.querySelectorAll('script').forEach(function (old) {
        var s = document.createElement('script');
        if (old.src) { s.src = old.src; s.async = false; }
        else s.textContent = old.textContent || '';
        old.parentNode.replaceChild(s, old);
      });
    }

    function apply(html) {
      if (!html || html.indexOf(mark) === -1) return false;
      var target =
        document.querySelector('#MainContent [id^="shopify-section"]') ||
        document.querySelector('[id^="shopify-section-template"]') ||
        document.getElementById('MainContent');
      if (!target) return false;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.firstElementChild || tmp;
      if (target.id === 'MainContent') {
        var old = target.querySelector('[id^="shopify-section"]') || target.firstElementChild;
        if (old) old.replaceWith(fresh);
        else target.prepend(fresh);
      } else {
        target.replaceWith(fresh);
      }
      runScripts(fresh);
      document.body.setAttribute('data-fit-custom-ref', 'boot');
      return true;
    }

    function tryKey(key, next) {
      fetch('/pages/custom-fit-order?sections=' + encodeURIComponent(key), {
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && (data[key] || data['custom-fit-page']);
          if (!apply(html) && typeof next === 'function') next();
        })
        .catch(function () {
          if (typeof next === 'function') next();
        });
    }

    var host = document.querySelector('#MainContent [id^="shopify-section"]');
    var secId = host && host.id ? host.id.replace(/^shopify-section-/, '') : null;
    var keys = [];
    if (secId) keys.push(secId);
    keys.push('custom-fit-page');

    function next() {
      if (!keys.length) return;
      tryKey(keys.shift(), next);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', next);
    } else {
      next();
    }
    setTimeout(next, 400);
  } catch (e) {}
})();

/* FIT_COL_LIVE_BOOT_VIA_FORM_ASSIST — load single binder only */
(function(){
  try{
    if((location.pathname||'').indexOf('/collections/')!==0) return;
    if(!window.__FIT_COL_FILTERS_SRC){
      window.__FIT_COL_FILTERS_SRC=1;
      var s=document.createElement('script');
      s.src='https://fitprotection.com/cdn/shop/t/102/assets/fit-col-filters-v17d.js?v=bind-r3-20260817h';
      s.async=false;
      (document.head||document.documentElement).appendChild(s);
    }
    function rebind(){ try{ if(window.__fitColFiltersBind) window.__fitColFiltersBind(true); }catch(e){} }
    setTimeout(rebind, 100);
    setTimeout(rebind, 500);
    setTimeout(rebind, 1500);
  }catch(e0){}
})();
